import React from 'react';

export default function IconCommunity() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66666 12.5003L4.33333 14.2503V12.5003H4.32166C3.68 12.5003 3.16666 11.9753 3.16666 11.3336V5.50028C3.16666 4.85862 3.69166 4.33362 4.33333 4.33362H13.6667C14.3083 4.33362 14.8333 4.85862 14.8333 5.50028V9.00029"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 10.5575H9.39084C8.53334 10.5575 7.83334 11.2516 7.83334 12.115V12.8908C7.83334 13.3225 8.18334 13.6666 8.60917 13.6666H14.0517C14.4833 13.6666 14.8275 13.3166 14.8275 12.8908V12.115C14.8275 11.2575 14.1333 10.5575 13.27 10.5575H11.3275H11.3333Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 9.39079C12.1935 9.39079 12.8908 8.69347 12.8908 7.83329C12.8908 6.9731 12.1935 6.27579 11.3333 6.27579C10.4731 6.27579 9.77583 6.9731 9.77583 7.83329C9.77583 8.69347 10.4731 9.39079 11.3333 9.39079Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.41666 9.00027L6.66666 7.25027"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 10.5581V11.9173"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
